// NEXON STORE — nexon.js

document.addEventListener('DOMContentLoaded', function () {

  // --- NAVBAR SCROLL ---
  const nav = document.getElementById('nexon-nav');
  if (nav) {
    window.addEventListener('scroll', function () {
      if (window.scrollY > 20) {
        nav.classList.add('scrolled');
      } else {
        nav.classList.remove('scrolled');
      }
    });
  }

  // --- MOBILE MENU ---
  const mobileToggle = document.getElementById('mobileToggle');
  const mobileMenu = document.getElementById('mobileMenu');
  if (mobileToggle && mobileMenu) {
    mobileToggle.addEventListener('click', function () {
      mobileMenu.classList.toggle('open');
    });
    mobileMenu.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', function () {
        mobileMenu.classList.remove('open');
      });
    });
  }

  // --- GALLERY THUMBNAILS ---
  const galleryMain = document.getElementById('galleryMain');
  const thumbs = document.querySelectorAll('.nexon-gallery__thumb');
  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      const src = thumb.dataset.src;
      if (galleryMain && src) {
        galleryMain.style.opacity = '0';
        galleryMain.style.transition = 'opacity 0.2s';
        setTimeout(function () {
          galleryMain.src = src;
          galleryMain.style.opacity = '1';
        }, 200);
      }
      thumbs.forEach(function (t) {
        t.classList.remove('nexon-gallery__thumb--active');
      });
      thumb.classList.add('nexon-gallery__thumb--active');
    });
  });

  // --- SCROLL REVEAL ---
  const revealEls = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('revealed');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '-80px 0px' });
    revealEls.forEach(function (el) {
      observer.observe(el);
    });
  } else {
    revealEls.forEach(function (el) {
      el.classList.add('revealed');
    });
  }

  // --- SMOOTH SCROLL FOR ALL ANCHOR LINKS ---
  document.querySelectorAll('a[href^="#"]').forEach(function (anchor) {
    anchor.addEventListener('click', function (e) {
      const href = anchor.getAttribute('href');
      if (href && href.length > 1) {
        const target = document.querySelector(href);
        if (target) {
          e.preventDefault();
          const offset = 80;
          const top = target.getBoundingClientRect().top + window.pageYOffset - offset;
          window.scrollTo({ top: top, behavior: 'smooth' });
        }
      }
    });
  });

});
